module.exports = __webpack_public_path__ + "static/media/CNBC_Economist_Logo_White.3f6a12c3.svg";